import {
  workApprovalProxy,
  workApprovalProxyBody,
  workConfigProxy,
  workBizTripProxy, // proxy/work/bizTrip/
  workBizTripProxyBody,
  workCodeProxy, // proxy/work/code/1.0/
  elaViewProxy,
  elaApiProxy,
  empCertiProxy, // proxy/emp/certi/
  empCertiProxyBody, // proxyBody/emp/certi/
} from './index';

import applCode from '@/const/applCodeConstants';

// workApprovalProxy : proxy/work/approval/
// workApprovalProxyBody : proxyBody/work/approval/

// ======================== EMP ========================
function getCertiApplCdList(params) {
  return elaApiProxy.get('appl/code', { params });
}

function getCertiApplList(params) {
  return empCertiProxy.get('application/1.0/mobile/list', { params });
}

function getCertiDet(params) {
  return empCertiProxy.get('detail/1.0/list', { params });
}

function postCertiDet(params) {
  return empCertiProxyBody.post('detail/1.0/detail/mobile-save', params);
}

// ======================= VACATION =======================
// 잔여연차 조회
function getRestCnt(params) {
  //'vacation/det/1.0/searchTime/restcnt
  return workApprovalProxy.get('vacation/det/1.0/restcnt', {
    params,
  });
}

// 전체일수, 휴일일수 조회
function getHoliCnt(params) {
  return workApprovalProxy.get('vacation/det/1.0/holicnt', {
    params,
  });
}

// 근태 - 재직상태 및 신청대상자 체크
function checkVacationDet(params) {
  return workApprovalProxy.get('vacation/det/1.0/check', {
    params,
  });
}

// 근태 - 신청서 저장
function postVacationDet(params) {
  return workApprovalProxyBody.post('vacation/det/1.0/save', params);
}

// 근태 - 신청서 조회
function getVacationMap(params) {
  return workApprovalProxy.get('vacation/det/1.0/map', { params });
}

// 휴일근무 조회
function getHolWork(params) {
  return workApprovalProxy.get('vacation/det/1.0/holwork', { params });
}

// 적용시간 계산 조회
function getHour(params) {
  return workApprovalProxy.get('vacation/det/1.0/hour', { params });
}

// ======================= OTWORK =======================

// 휴일근무 보상구분 조회
function getOtWorkSysInfo() {
  return workApprovalProxy.get('otwork/det/1.0/sys/info');
}

// 연장근무 재직상태 조회
// 필수: ssnEnterCd, workYmd, workYmd, searchApplSabun
function getOtWorkStatus(params) {
  return workApprovalProxy.get('otwork/det/1.0/status', { params });
}

// 연장근무 신청시간 조회
function getOtWorkHour(params) {
  return workApprovalProxy.get('otwork/det/1.0/hour', { params });
}

// 2025.03.12 개인 근무유형별 연장근무 직접입력가능 여부 조회
function getOtDirectYn(params) {
  return workApprovalProxy.get('otwork/det/1.0/otDirectYn', { params });
}

// 연장근무 - 대체휴가 데이터 확인
function checkOtWorkAlter(params) {
  return workApprovalProxy.get('otwork/det/1.0/alter/check', { params });
}

// 연장근무 24시간 스케줄 조회
function getOtWorkTimeList(params) {
  return workApprovalProxy.get('otwork/det/1.0/time/list', { params });
}

// 연장근무 - 재직상태 및 신청대상자 체크
// 필수: ssnEnterCd, searchApplSabun, searchApplSeq, workYmd, requestHour
function checkOtWorkDet(params) {
  return workApprovalProxy.get('otwork/det/1.0/check', {
    params,
  });
}

// 연장근무 - 신청서 저장
function postOtWorkDet(params) {
  return workApprovalProxyBody.post('otwork/det/1.0/save', params);
}

// 연장근무 - 신청서 조회
function getOtWorkMap(params) {
  return workApprovalProxy.get('otwork/det/1.0/list', { params });
}

// ======================= SCHEDULE =======================

// 근무유형 근무시간 조회
// 필수: ssnEnterCd, searchWorkTypeCd
function getWorkOrgTimeList(params) {
  return workConfigProxy.get('/workorg/1.0/time/list', { params });
}

// 개인근무스케쥴 스케쥴 조회
// 필수: ssnEnterCd, searchApplSabun, stdYmd
function getScheduleStatus(params) {
  return workApprovalProxy.get('schedule/det/1.0/status', { params });
}

// 개인근무스케쥴 - 신청체크
// 필수: ssnEnterCd, searchApplSabun, sdate, edate, searchApplSeq
function checkScheduleDet(params) {
  return workApprovalProxy.get('schedule/det/1.0/check', {
    params,
  });
}

// 개인근무스케쥴 - 신청서 저장
function postScheduleDet(params) {
  return workApprovalProxyBody.post('schedule/det/1.0/one/save', params);
}

// 개인근무스케쥴 - 신청서 조회
function getScheduleMap(params) {
  return workApprovalProxy.get('schedule/det/1.0/map', { params });
}

// 개인근무스케쥴 - 스케줄 변경일 정보 조회
// 필수: ssnEnterCd, searchApplSabun, sdate, edate
function getScheduleTimeOne(params) {
  return workApprovalProxy.get('schedule/det/1.0/time/one', { params });
}

// ======================= REWARD =======================

// 보상휴가 - 전체일수, 휴일일수 조회
function getRewardHoliCnt(params) {
  return workApprovalProxy.get('reward/det/1.0/holicnt', {
    params,
  });
}

// 보상휴가신청 보상조회
function getRewardList(params) {
  return workApprovalProxy.get('/reward/det/1.0/list', { params });
}

// 보상휴가 - 재직상태 및 신청대상자 체크
function checkRewardDet(params) {
  return workApprovalProxy.get('reward/det/1.0/check', {
    params,
  });
}

// 보상휴가 - 신청서 저장
function postRewardDet(params) {
  return workApprovalProxyBody.post('reward/det/1.0/save', params);
}

// 보상휴가 - 신청서 조회
function getRewardMap(params) {
  return workApprovalProxy.get('reward/det/1.0/map', { params });
}

// ======================= ATTEND =======================

// 출퇴근변경신청 - 스케줄조회
// 필수: ssnEnterCd, searchApplSabun, workYmd
function getAttendStatus(params) {
  return workApprovalProxy.get('attend/det/1.0/status', { params });
}

// 출퇴근변경신청 - 재직상태 및 신청대상자 체크
function checkAttendDet(params) {
  return workApprovalProxy.get('attend/det/1.0/check', {
    params,
  });
}

// 출퇴근변경신청 - 신청서 저장
function postAttendDet(params) {
  return workApprovalProxyBody.post('attend/det/1.0/save', params);
}

// 출퇴근변경신청 - 신청서 조회
function getAttendMap(params) {
  return workApprovalProxy.get('attend/det/1.0/list', { params });
}

// ====================== VACATION =========================

// 2025.03.19 근태신청 - 근태별 파일첨부필수여부 체크
function getApprovalMgrApplFileEssYn(params) {
  return elaViewProxy.get('search/gntFileEssYn', { params });
}

// ======================= BIZTRIP =======================
// 출장신청구분조회
function getBizTripType(params) {
  return workCodeProxy.get('list', { params });
}

// 휴가일수조회
function checkHolCnt(params) {
  return workBizTripProxy.get('app/det/1.0/holcnt', { params });
}

// 출장신청서 상세조회
function getBizTripAppDet(params) {
  return workBizTripProxy.get('app/det/1.0/list', { params });
}

// 출장신청서 저장
function postBizTripAppDet(params) {
  return workBizTripProxyBody.post('app/det/1.0/save', params);
}

// ======================= CANCEL =========================

// 근태취소신청 - 신청 확인
function checkCancelVacation(params) {
  return workApprovalProxy.get('vacation/upd/det/1.0/check', { params });
}
// 근태취소신청 - 신청서 저장
function postCancelVacation(params) {
  return workApprovalProxyBody.post('vacation/upd/det/1.0/save', params);
}
// 근태취소신청 - 신청서 조회
function getCancelVacationMap(params) {
  return workApprovalProxy.get('vacation/upd/det/1.0/map', { params });
}
// 근태취소신청 - 신청서 회수
function deleteCancelVacation(params) {
  return workApprovalProxyBody.post('vacation/app/1.0/save2', params);
}

// 보상휴가취소신청 - 신청 확인
function checkCancelReward(params) {
  return workApprovalProxy.get('reward/upd/det/1.0/check', { params });
}
// 보상휴가취소신청 - 신청서 저장
function postCancelReward(params) {
  return workApprovalProxyBody.post('reward/upd/det/1.0/save', params);
}
// 보상휴가취소신청 - 신청서 조회
function getCancelRewardMap(params) {
  return workApprovalProxy.get('reward/upd/det/1.0/map', { params });
}

// 신청서 회수 (공통)
function deleteApplication(applCd, params) {
  let url = '';
  if (applCd === applCode.Vacation) {
    url = 'vacation/app/1.0/save';
  } else if (applCd === applCode.OtWork) {
    url = 'otwork/app/1.0/save';
  } else if (applCd === applCode.Schedule) {
    url = 'schedule/app/1.0/save';
  } else if (applCd === applCode.Reward) {
    url = 'reward/app/1.0/save';
  } else if (applCd === applCode.Attend) {
    url = 'attend/app/1.0/save';
  } else if (applCd === applCode.CancelVacation) {
    url = 'vacation/app/1.0/save2';
  } else if (applCd === applCode.CancelReward) {
    url = 'reward/app/1.0/save2';
  }
  return workApprovalProxyBody.post(url, params);
}

export {
  // 근태
  getRestCnt,
  getHoliCnt,
  checkVacationDet,
  postVacationDet,
  getVacationMap,
  getHolWork,
  getHour,
  // 연장근무
  getOtWorkSysInfo,
  getOtWorkStatus,
  getOtWorkHour,
  getOtDirectYn,
  checkOtWorkAlter,
  getOtWorkTimeList,
  checkOtWorkDet,
  postOtWorkDet,
  getOtWorkMap,
  // 근무스케줄
  getWorkOrgTimeList,
  getScheduleStatus,
  checkScheduleDet,
  postScheduleDet,
  getScheduleMap,
  getScheduleTimeOne,
  // 보상휴가
  getRewardHoliCnt,
  getRewardList,
  checkRewardDet,
  postRewardDet,
  getRewardMap,
  // 2025.03.19 근태신청
  getApprovalMgrApplFileEssYn,
  // 출퇴근변경신청
  getAttendStatus,
  checkAttendDet,
  postAttendDet,
  getAttendMap,
  // 출장신청
  getBizTripType,
  checkHolCnt,
  getBizTripAppDet,
  postBizTripAppDet,
  // 취소신청
  checkCancelVacation,
  postCancelVacation,
  getCancelVacationMap,
  deleteCancelVacation,
  checkCancelReward,
  postCancelReward,
  getCancelRewardMap,
  deleteApplication,
  // 제증명신청
  getCertiApplCdList,
  getCertiApplList,
  getCertiDet,
  postCertiDet,
};
